import React from 'react';
import { FormHelpText } from '@spotify-internal/encore-web';
import { FieldError } from 'client/shared/FieldController';
import { getCharacterCountText } from 'client/modules/getCharacterCountText';
import { BottomSection, CharacterCount } from './styles';

export function FieldBottomSection({
  showCharacterCount,
  isShowingError,
  value,
  error,
  maxCharacterLength,
  errorContainerId,
}: {
  value?: string | string[] | number;
  isShowingError?: boolean;
  showCharacterCount?: boolean;
  error?: FieldError;
  maxCharacterLength?: number;
  errorContainerId?: string | undefined;
}) {
  const isShowingBottomSection =
    showCharacterCount || (isShowingError && error?.message);

  if (!isShowingBottomSection) {
    return null;
  }

  return (
    <BottomSection>
      {isShowingError && (
        <FormHelpText error={true} id={errorContainerId}>
          {error?.message}
        </FormHelpText>
      )}
      {showCharacterCount && (
        <CharacterCount maxChars={maxCharacterLength}>
          {getCharacterCountText(value, maxCharacterLength)}
        </CharacterCount>
      )}
    </BottomSection>
  );
}
